<div class="side-menu-container row" (mouseenter)="mouseenter()" (mouseleave)="mouseleave()" [ngClass]="{open: isMenuOpen}">
    <!-- -->
    <div class="side-menu full-width">
        <div class="top-menu-part row">
            <div class="menu-icon desktop">
                <img src="assets/images/icons/‏‏menu-icon-primary-color.svg">
            </div>
            <button class="menu-icon mobile" (click)="openMenu()" [hidden]="isMenuOpen">
                <img src="assets/images/icons/menu-icon-white.svg">
            </button>
            <button class="menu-icon mobile" (click)="closeMenu()" [hidden]="!isMenuOpen">
                <img src="assets/images/icons/close-menu.svg">
            </button>
            <a class="logo-icon">
                <img src="assets/images/icons/menu_logo-icon.svg" [routerLink]="''" [queryParams]="{viewMode: true}">
            </a>
        </div>

        <div class="column">
            <a class="row menu-item" *ngFor="let item of menuItems; let i = index;" [routerLink]="item.routerLink"
                routerLinkActive="active-menuitem-routerlink" (click)="closeMenu()"
                [routerLinkActiveOptions]="{ matrixParams: 'exact', queryParams: 'exact', paths: 'exact', fragment: 'exact' }"
                [attr.target]="item.target" [attr.tabindex]="0">
                <i>
                    <img src="assets/images/icons/{{item.icon}}.svg" />
                </i>
                <div>
                    {{item.label}}
                </div>
            </a>

        </div>
        <!-- <span class="fixed-logo"></span> -->
    </div>
</div>